<template>
  <div class="shadow-fixed show">
    <div class="mask"></div>
    <div class="visaflow-box">
      <div class="visaflow-small-close" @click="closeVf"></div>
      <div class="visaflow-inner">
        <p>请填写本次签证流的标题</p>
        <input type="text" class="visaflow-input" v-model="title" />
        <d-upload @getPicArr="getPicArr($event)" :src="src"></d-upload>
      </div>
      <div class="visaflow-btn" @click="create">
        <span>确定</span>
      </div>
    </div>
  </div>
</template>

<script>
import "../../../../../html/components/d-visaflow/d-visaflow.scss"

import dUpload from "./d-upload"

import { CreateVisaflow } from '../../../../../api/index'

export default {
  name: 'd-visaflow',
  data() {
    return {
      picArr: [],
      src: require('../../../../../html/components/d-visaflow/images/upload.png'),
      title: ''
    }
  },
  components: {
    dUpload
  },
  methods: {
    getPicArr(data) {
      this.picArr = data;
    },
    closeVf() {
      this.$emit('closeVf')
    },
    async create() {
      if (this.title.trim().length == 0) {
        this.$layer.alert('标题不能为空');
      } else if (this.picArr.length == 0) {
        this.$layer.alert('图片不能为空');
      } else {
        let res = await CreateVisaflow({
          forumId: this.$route.params.id,
          Title: this.title,
          ImgPaths: this.picArr.join()
        })
        // console.log(res);
        if(res.Type == "Success"){
          this.$layer.alert('创建成功',(layerid)=>{
            this.$layer.close(layerid);
            this.$emit('closeVf');
            this.$emit('initVf')
          })
        }
      }
    }
  },
  created() {
  }
}
</script>